import * as React from 'react';

import { RootLayout } from './src/utils/RootLayout';

export const wrapRootElement = ({ element }) => (
  <RootLayout>{element}</RootLayout>
);
